<script lang="ts" setup>
import { computed } from '#imports';

type Props = {
  name: string;
  color: string;
};
type Emits = {
  (e: 'inputColor', v: string): void;
  (e: 'inputFocus', v: boolean): void;
};

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const modelColor = computed({
  get: () => props.color || '',
  set: value => emit('inputColor', value)
});

function handleFocus(status: boolean) {
  emit('inputFocus', status);
}
</script>

<template>
  <div class="CP-box CP--box-border">
    <span class="CP-box__name">
      {{ name }}
    </span>
    <input
      :id="name"
      v-model="modelColor"
      type="text"
      class="CP-box__value"
      @focusin="handleFocus(true)"
      @focusout="handleFocus(false)"
    >
  </div>
</template>

<style>
.CP-box{display:flex;font-size:12px}.CP-box__name{align-items:center;background:var(--colorPickerInputTitleBg);color:var(--colorPickerInputTitle);display:flex;float:left;height:30px;justify-content:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:60px}.CP-box__value{background:var(--colorPickerInputTextBg);border:0;color:var(--colorPickerInputText);cursor:text;flex:1;height:30px;min-width:100px;padding:0 12px}.CP-box__value:focus{outline:none}
</style>
